const {
  product, // product liquid object
  sizeGuides, // size guide section data
} = globalThis.PS;

// Size Guides
const $sizeGuideTab = document.querySelector('.size-guide-tab');
const $sizeGuideTabLink = $sizeGuideTab.querySelector('.t4s-tab__title');
const $sizeGuideTabInner = $sizeGuideTab.querySelector('.t4s-tab-content');
const $sizeGuideImage = $sizeGuideTab.querySelector('.size-guide-image');
const $sizeGuideModal = document.querySelector('.size-guide-modal');
const $sizeGuideModalOverlay = document.querySelector('.size-guide-modal-overlay');
let hasSizeGuide = false;
let hasClonedSizeGuide = false;

if (sizeGuides && $sizeGuideImage) {
  if (sizeGuides[product.type]) {
    // Add correct size guide image
    $sizeGuideImage.src = sizeGuides[product.type].image;

    // Add event listener on desktop to open modal with image
    window.addEventListener('resize', checkWindowSize);
    checkWindowSize();

    hasSizeGuide = true;
  }
  
  if (!hasSizeGuide) {
    $sizeGuideTab.remove();
  }
}

PS.closeSizeGuideModal = function() {
  $sizeGuideModalOverlay.classList.remove('is-active');
  $sizeGuideModal.classList.remove('is-active');
}

function openModalWithImage() {
  if (!hasClonedSizeGuide) {
    const $clonedSizeGuide = $sizeGuideTabInner.cloneNode(true);
    $clonedSizeGuide.classList.remove('t4s-tab-content');
    $sizeGuideModal.appendChild($clonedSizeGuide);
    hasClonedSizeGuide = true;
  }

  $sizeGuideModalOverlay.classList.add('is-active');
  $sizeGuideModal.classList.add('is-active');
}

function handleTabClick(event) {
  event.preventDefault();
  openModalWithImage();
}

function checkWindowSize() {
  if (window.innerWidth >= 768) {
    $sizeGuideTabLink.removeAttribute('data-t4s-tab-item');
    $sizeGuideTabLink.addEventListener('click', handleTabClick);
  } else {
    $sizeGuideTabLink.setAttribute('data-t4s-tab-item', '');
    $sizeGuideTabLink.removeEventListener('click', handleTabClick);
  }
}
